import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	main: {
		data: []
	},
	preview: {
		data: []
	},
	isLoaded: false,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** FETCH PACKET'S MATERIALS ******************
			case types.FETCH_PACKET_MATERIALS_LOADING:
				draft.main.data = [];
				draft.isLoaded = false;
				draft.error = false;
				return;

			case types.FETCH_PACKET_MATERIALS_SUCCESS:
				draft.main.data = action.payload.filter(({ type }) => type === 'main');

				draft.preview.data = action.payload.filter(
					({ type }) => type === 'preview'
				);
				draft.isLoaded = true;
				return;

			case types.FETCH_PACKET_MATERIALS_ERROR:
				draft.main.isLoaded = true;
				draft.error = true;
				return;

			// ****************** UPDATE / DELETE PACKET'S MATERIALS ******************
			case types.UPDATE_PACKET_MATERIALS:
				draft.error = false;
				// gets type data and productId
				const { data, type, productId } = action.payload;
				const assetId = data.id;
				const assets = draft[type].data.filter(({ id }) => id === productId)[0]
					.assets;

				// select asset which data will be modified
				const selectAsset = assets.find((asset) => asset.id === assetId);

				// if there is an specified asset in product asset then modify its data
				// else add new asset to product
				if (selectAsset) {
					selectAsset.src = data.src;
					selectAsset.drm_key = data.drm_key;
					selectAsset.format = data.format;
					selectAsset.platform = data.platform;
				} else {
					assets.push(data);
				}

				return;

			case types.UPDATE_PACKET_MATERIALS_ERROR:
				draft.error = true;
				return;

			case types.DELETE_PACKET_MATERIALS:
				draft.error = false;
				draft[action.payload.type].data.map(
					(product) =>
						(product.assets = product.assets.filter(
							(asset) => asset.id !== action.payload.id
						))
				);
				return;

			case types.DELETE_PACKET_MATERIALS_ERROR:
				draft.error = true;
				return;

			default:
				return state;
		}
	});
